<template lang="pug">
#PedirRepuestosBodega
  b-button(
    variant="action"
    @click="showModalRepuestos()"
  )
    | Pedir Repuestos Bodega
  b-modal(
    v-model="showModal"
    :title="'Pedir Repuestos Bodega ID ' + dataOv.id"
  )
    b-row
      b-col(cols="12")
        img(src="@/assets/icons/replacement.svg" alt="Repuestos" style="width: 23px; height: 23px; margin-right: 5px")
        span.title.ml-2 Repuestos
      //- tabla sin bordes
      table.table.table-borderless.table-hover
        thead
          tr
            th N° de parte
            th Descripción
            th Disponible
        tbody
          tr(v-for="(repuesto, index) in repuestosForm" :key="index")
            td {{ repuesto.nSerie }}
            td {{ repuesto.descripcion }}
            td
              b-form-checkbox(
                v-model="repuesto.disponible"
              ) Sí
    template(#modal-footer='{ ok, cancel, hide }')
      .d-flex.justify-content-between(style='width: 100%')
        b-button(size='sm' variant='secondary' @click='hideModal' :disabled="loading") Cancelar
          b-spinner(v-if="loading" small)
        b-button(size='sm' variant='primary' @click='saveParts' :disabled="loading" id="ov-action-accept-parts") Aceptar
          b-spinner(v-if="loading" small)
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import print from '@/utils/print'
import moment from 'moment'

export default {
  name: 'PedirRepuestosBodega',
  props: {
    dataOv: {
      type: Object,
      required: true
    },

  },
  data () {
    return {
      showModal: false,
      loading: false,
      repuestosForm: [
        {
          id: '',
          nSerie: '',
          disponible: false
        }
      ],
    }
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
  },
  methods: {
    ...mapActions('OVStore', ['requestParts', 'getOvDetail']),
    showModalRepuestos() {
      this.showModal = true;
    },
    hideModal() {
      this.showModal = false;
    },
    async printOVParts() {
      const { data } = await this.getOvDetail(this.dataOv.id)
      const oportunidadVenta = { ...data }
      oportunidadVenta.vendedor = `${this.user.first_name} ${this.user.last_name}`
      print(
        this.dataOv.id,
        this.repuestosForm,
        oportunidadVenta,
        moment().format('DD/MM/YYYY H:mm:ss'),
        'OV'
      )
    },
    saveParts() {
      this.loading = true;
      const repuestos = this.repuestosForm.map((item) => {
        return {
          id_detalle_venta: item.id,
          repuesto_disponiblidad: item.disponible
        }
      });
      this.requestParts({
        id_oportunidad_venta: this.dataOv.id,
        lista_detalle: repuestos
      }).then(async () => {
        await this.printOVParts()
        this.$emit('reloadAll')
      }).catch((error) => {
        console.error('Error al pedir repuestos:', error)
      }).finally(() => {
        this.loading = false
        this.hideModal()
      })
    },
  },
  created() {
    this.repuestosForm = this.dataOv.detalle_venta.map((item) => {
      return {
        id: item.id,
        nSerie: item.parte.part_number,
        disponible: true,
        descripcion: item.parte.description,
        real_location: item.parte.real_location
      }
    });
  },
}
</script>
<style lang="scss">
.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #23201C !important;
  border-color: #23201C !important;
}
</style>
